import {color} from "#graph/serialization/color"
import {z} from "zod/v4-mini"

export const editorNodeUiSchema = z.optional(
    z.object({
        internalColor: z.optional(color),
        internalLabel: z.optional(z.string()),
        position: z.object({
            x: z.number(),
            y: z.number(),
        }),
    }),
)
